import React from 'react';
import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import {
   getParticipantDisplayName,
   getParticipantById
} from '../../../base/participants';

function RedirectToPrivateRoom({_url}){

   return (
      <div style={{
         position: 'absolute',
         top: '10%',
         width: '100%',
         height: '83%',
         zIndex: '100',
         cursor: 'pointer',
      }} onClick={() => location.assign(_url)} />
   )
}

function _mapStateToProps(state, ownProps) {
   const { participantID } = ownProps;
   const participant = getParticipantById(state, participantID);
   const _nameToDisplay = getParticipantDisplayName(state, participantID)

   const { displayName:displayNameLocal } = state["features/base/settings"]
   const roomPV = _nameToDisplay.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "-")
   const _url = `${roomPV}#userInfo.displayName=%22${encodeURIComponent(displayNameLocal)}%22`

   return { _url }
}

export default translate(connect(_mapStateToProps)(RedirectToPrivateRoom));
